import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationPrevious,
  PaginationText,
  PaginationEllipsis,
  PaginationNext,
} from "@components/ui/pagination";

type PaginationNewProps = {
  max: number;
  page: number;
  onChangePage: (value: number) => void;
};

export default function PaginationNew({
  page,
  max,
  onChangePage,
}: PaginationNewProps) {
  return (
    <Pagination>
      <PaginationContent>
        <PaginationItem>
          <PaginationPrevious
            disabled={page <= 1}
            onClick={() => {
              onChangePage(page - 1);
            }}
          />
        </PaginationItem>
        <PaginationItem>
          <PaginationText isActive>{page}</PaginationText>
        </PaginationItem>
        {page !== max ? (
          <>
            <PaginationItem>
              <PaginationEllipsis />
            </PaginationItem>
            <PaginationItem>
              <PaginationText>{max}</PaginationText>
            </PaginationItem>
          </>
        ) : null}
        <PaginationItem>
          <PaginationNext
            disabled={page >= max}
            onClick={() => {
              onChangePage(page + 1);
            }}
          />
        </PaginationItem>
      </PaginationContent>
    </Pagination>
  );
}
